import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

import {
	securityOidcConfigurationsByCustomerReducers,
	securityOidcConfigurationsByCustomerWatchers
} from './by-customer';
import {
	securityOidcConfigurationsBySubdomainReducers,
	securityOidcConfigurationsBySubdomainWatchers
} from './by-subdomain';

export const securityOidcConfigurationsReducers = combineReducers({
	byCustomer: securityOidcConfigurationsByCustomerReducers,
	bySubdomain: securityOidcConfigurationsBySubdomainReducers
});

export const securityOidcConfigurationsWatchers = combineAllWatchers([
	securityOidcConfigurationsByCustomerWatchers,
	securityOidcConfigurationsBySubdomainWatchers
]);
